import { useEffect, useRef, useState } from "react";
import AddressSearch from "../../components/address-search-box";
import { Coords, LocksmithNearestList } from "../../utils/types";
import { request } from "../../utils/request";
import { api } from "../../utils/api";
import { Map, useMap } from "@vis.gl/react-google-maps";
import { DefaultCenter, MapsRestriction } from "../../utils/constants";
import { AddressMarker, AddressMarkerRef } from "../../components/address-marker";
import { LocksmithMarker } from "../../components/locksmith-marker";

export default function NearestLocksmiths() {
    const [location, setLocation] = useState<Coords>();
    const map = useMap();
    // const placesLib = useMapsLibrary('places');
    const addressMarkerRef = useRef<AddressMarkerRef>(null);
    const [data, setData] = useState<LocksmithNearestList[]>([]);
    const [address, setAddress] = useState<string>('');
    // const [loading, setLoading] = useState(false);

    useEffect(() => {
        let interval: NodeJS.Timer;
        // setLoading(true)
        fetchNearestLocksmiths().then((res) => {
            setData(res.list)
            // setLoading(false)
        }).catch((error) => {
            // setLoading(false)
            setData([])
        })
        interval = setInterval(() => {
            fetchNearestLocksmiths().then((res) => {
                setData(res.list)
            }).catch((error) => {
                // setLoading(false)
                setData([])
            })
        }, 1000)
        return () => clearInterval(interval)
    }, [])

    const onChangeLatLong = (loc?: { coords: Coords, address_name: string }) => {
        setLocation(loc?.coords)
        addressMarkerRef.current?.setPosition(loc?.coords)
        addressMarkerRef.current?.setInfoText(loc?.address_name)
        setAddress(loc?.address_name ?? '')
        if (!loc) return;
        map?.moveCamera({ center: { lat: loc?.coords.latitude, lng: loc?.coords.longitude }, zoom: 15 })
    }

    return <div>
        <div className="absolute z-10 lg:w-1/3 w-2/3 mt-20 lg:mt-4 ml-5">
            <AddressSearch onChangeLatLong={onChangeLatLong} />
        </div>
        <Map
            reuseMaps
            minZoom={3}
            maxZoom={20}
            defaultZoom={4}
            disableDefaultUI
            scaleControl
            cameraControl
            fullscreenControl
            defaultCenter={DefaultCenter}
            clickableIcons={false}
            mapId={'locksmith-map'}
            gestureHandling={'greedy'}
            className='-mx-4 sm:-mx-6 lg:-mx-8 -mb-10 -mt-20 lg:-my-10 h-screen lg:h-screen'
            restriction={MapsRestriction}>
            <AddressMarker ref={addressMarkerRef} />
            {data.map(item => <LocksmithMarker key={item.id} address_coords={!location ? undefined : { lat: location?.latitude, lng: location?.longitude }} details={item} address={address} />)}
        </Map>
    </div>
}

const fetchNearestLocksmiths = async (
    // coords: Coords
) => {
    try {
        // const response = await request('GET', api.locksmith.nearest + `?disable_pagination=true&latitude=${coords.latitude}&longitude=${coords.longitude}&radius=10`)
        const response = await request('GET', api.locksmith.nearest + `?disable_pagination=true`)
        return response.data
    } catch (error) {
        throw error;
    }
}